/**
 * @generated SignedSource<<a0e6d45b296c7039ba2a2d287f86c3f5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleMoreOnThisListStyleArticle$data = {
  readonly styleMoreOnThisArticles: ReadonlyArray<{
    readonly entityId: string;
    readonly headline: string | null;
    readonly images: ReadonlyArray<{
      readonly style: {
        readonly url: string | null;
      } | null;
      readonly url: string;
    } | null> | null;
    readonly socialHeadline: string | null;
    readonly urlAlias: string;
    readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
  } | null> | null;
  readonly " $fragmentType": "articleMoreOnThisListStyleArticle";
};
export type articleMoreOnThisListStyleArticle$key = {
  readonly " $data"?: articleMoreOnThisListStyleArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleMoreOnThisListStyleArticle">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleMoreOnThisListStyleArticle",
  "selections": [
    {
      "alias": "styleMoreOnThisArticles",
      "args": null,
      "concreteType": "Article",
      "kind": "LinkedField",
      "name": "moreOnThisArticles",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "entityLink"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "entityId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "headline",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "socialHeadline",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlAlias",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Image",
          "kind": "LinkedField",
          "name": "images",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "filter",
                  "value": {
                    "style": "768x768"
                  }
                }
              ],
              "concreteType": "ImageStyle",
              "kind": "LinkedField",
              "name": "style",
              "plural": false,
              "selections": [
                (v0/*: any*/)
              ],
              "storageKey": "style(filter:{\"style\":\"768x768\"})"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};
})();

(node as any).hash = "377300113f41276242445a9e2c28e84b";

export default node;
